import React from "react";

const Layout = ({ children, title = "SmartRemont|CRM" }) => {
  document.title = title;
  return <>{children}</>;
};

export default Layout;
